import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_INSURED_ENTITY = graphql(`
  query getInsuredEntity($uuid: String!) {
    entities(filters: { entityUuid: $uuid }) {
      edges {
        node {
          uuid
          referenceId
          type
          documentLink
          submissionType
          agency
          createdAt
          updatedAt
          status

          fundamentals {
            edges {
              cursor
              node {
                yearEstablished
                uuid
                revenue
                projectedRevenue
                employees
                sources
                score
                createdAt
                updatedAt
                primary
              }
            }
          }
          industrySectors {
            edges {
              cursor
              node {
                uuid
                name
                naicsCode
                sources
                createdAt
                updatedAt
                primary
              }
            }
          }
          domains {
            edges {
              cursor
              node {
                uuid
                domain
                sources
                primary
              }
            }
          }
          addresses {
            edges {
              cursor
              node {
                uuid
                street1
                street2
                city
                regions {
                  edges {
                    cursor
                    node {
                      uuid
                      name
                    }
                  }
                }
                type
                postalCode
                countries {
                  edges {
                    cursor
                    node {
                      uuid
                      name
                      iso2Code
                      iso3Code
                    }
                  }
                }
                source
                primary
              }
            }
          }
          persons {
            edges {
              cursor
              node {
                uuid
                firstName
                lastName
                agent
                title
                type
                source
                personType {
                  uuid
                  type
                  title
                }
                primary
                contacts {
                  edges {
                    cursor
                    node {
                      uuid
                      type
                      value
                      source
                      primary
                    }
                  }
                }
              }
            }
          }
          aliases(filters: { groupSources: true }) {
            edges {
              cursor
              node {
                uuid
                name
                type
                sources
                createdAt
                updatedAt
                primary
              }
            }
          }
        }
      }
    }
  }
`);

export function useInsuredEntityQuery(uuid: string) {
  const { loading, error, data } = useQuery(GET_INSURED_ENTITY, {
    variables: {
      uuid: uuid,
    },
  });

  return {
    error,
    loading,
    data,
  };
}
